import { IReactionDisposer } from 'mobx';

export default class Disposer {
    protected readonly reactions: Array<IReactionDisposer> = [];

    disposeReactions() {
        this.reactions.forEach(disposer => disposer());
    }
}
